import { lazy, Suspense } from "react";
import { closeSheet, useOpenSheet } from "./sheetStore";

const NotificationsSheet = lazy(() => import("./NotificationsSheet"));
const AccountSheet = lazy(() => import("./AccountSheet"));
const ConfigurationScreen = lazy(() => import("./ConfigurationScreen"));

/** Draws whichever app-wide sheet is open: notifications, account, configuration. */
export default function MobileSheetsHost() {
  const open = useOpenSheet();
  if (!open) return null;
  return (
    <Suspense fallback={null}>
      {open === "notifications" ? <NotificationsSheet open onClose={closeSheet} /> : null}
      {open === "account" ? <AccountSheet open onClose={closeSheet} /> : null}
      {open === "configuration" ? <ConfigurationScreen open onClose={closeSheet} /> : null}
    </Suspense>
  );
}
